import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Mail, Phone, MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { useSeo } from "@/hooks/useSeo";
import { SectionHeader } from "@/components/ui-kit";

export default function Contact() {
  useSeo("Contact", "Contact Golden Wolf Foundation in Chicago.");
  const [f, setF] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post("/contact", f); toast.success("Message sent — we'll be in touch."); setF({ name: "", email: "", phone: "", subject: "", message: "" }); }
    catch { toast.error("Could not send message"); } finally { setLoading(false); }
  };
  return (
    <div className="max-w-5xl mx-auto px-6 py-16">
      <SectionHeader overline="Get In Touch" title="Contact Us" sub="Questions, partnerships or press — reach out and our team will respond." />
      <div className="grid lg:grid-cols-3 gap-8">
        <div className="space-y-4">
          {[[MapPin, "North Lawndale, Chicago, IL"], [Mail, "hello@goldenwolfvets.org"], [Phone, "(630) 440-3760"]].map(([I, v]) => (
            <div key={v} className="gw-card p-5 flex gap-3"><I className="w-5 h-5 text-[#D4AF37]" /><span className="text-[#C8C4B7]">{v}</span></div>
          ))}
        </div>
        <form onSubmit={submit} className="lg:col-span-2 gw-card p-7 grid sm:grid-cols-2 gap-4">
          <input required placeholder="Name *" className="gw-input" data-testid="contact-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
          <input type="email" required placeholder="Email *" className="gw-input" data-testid="contact-email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
          <input placeholder="Phone" className="gw-input" data-testid="contact-phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} />
          <input placeholder="Subject" className="gw-input" data-testid="contact-subject" value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} />
          <textarea rows={5} required placeholder="Message *" className="gw-input sm:col-span-2" data-testid="contact-message" value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} />
          <button disabled={loading} className="btn-gold sm:col-span-2 flex items-center justify-center gap-2 py-3.5" data-testid="contact-submit">{loading && <Loader2 className="w-4 h-4 animate-spin" />} Send Message</button>
        </form>
      </div>
    </div>
  );
}
